export const environment = {
  production: false, // add sourcemaps
  env: 'staging',
  apiUrl: '/api/v1',
  s3Url: 'https://sips-dev-deal-images.s3-us-west-2.amazonaws.com',
};
